<template>
  <article class="deal-card">
    <h3 v-if="title" class="deal-card__title">{{ title }}</h3>
    <slot />
  </article>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.deal-card {
  border-radius: $sp-s;
  box-shadow: 0 0 12px rgba(26, 27, 60, 0.16);
  padding: $sp-m;

  @include for('tablet') {
    border: 1px solid getShade($quaternary-color, 50);
    box-shadow: none;
  }

  &__title {
    @include font('DS-200');
    font-weight: 700;
    margin-bottom: $sp-m - $sp-xs;

    @include for('tablet') {
      @include font('DS-300');
    }
  }
}
</style>
